// extracted by mini-css-extract-plugin
module.exports = {"fade":"popup-module__fade___3rrHM"};